// node_modules/@jspm/core/nodelibs/browser/tty.js
function isatty() {
  return false;
}
function ReadStream() {
  throw new Error("tty.ReadStream is not implemented");
}
function WriteStream() {
  throw new Error("tty.WriteStream is not implemented");
}
var m = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ReadStream,
  WriteStream,
  isatty
});
export {
  ReadStream,
  WriteStream,
  m as default,
  isatty
};
